const transferPickupHintContent = (
    <p>
        Die Abholzeit vom Hafen richtet sich nach Ihrer Rückflugzeit und kann bei späten Flügen erst am Nachmittag oder
        Abend erfolgen. Die genaue Zeit finden Sie auf Ihrem Transfervoucher. Für eine mögliche frühere Abholung
        kontaktieren Sie uns bitte vor Reisebeginn unter{' '}
        <a href="mailto:service@aurumtours.de">service@aurumtours.de</a>.
    </p>
);
export default transferPickupHintContent;
